// Wave X-2 (2026-05-13) — 거래수수료 admin CRUD UI
// list / 입금확인 / 면제 — 인계는 별도 admin 운영 워크플로우(인계 시 POST). 본 화면은 사후 관리.

import React, { useState, useEffect } from 'react';
import { API, authFetch } from '../utils/api';

function AdminTransactionFees({ showToast, th, td, badge, btnStyle }) {
  var [items, setItems] = useState([]);
  var [status, setStatus] = useState('all');
  var [overdue, setOverdue] = useState(false);
  var [loading, setLoading] = useState(false);

  function fetchList() {
    setLoading(true);
    var q = 'status=' + encodeURIComponent(status) + (overdue ? '&overdue=1' : '');
    authFetch(API + '/admin/transaction-fees?' + q)
      .then(function(r) { return r.json(); })
      .then(function(d) {
        if (d && d.success) setItems((d.data && d.data.items) || []);
        else showToast && showToast((d && d.error) || '조회 실패', 'error');
      })
      .catch(function() { showToast && showToast('네트워크 오류', 'error'); })
      .finally(function() { setLoading(false); });
  }

  useEffect(function() { fetchList(); }, [status, overdue]);

  function markPaid(id) {
    if (!window.confirm('입금 확인 처리하시겠습니까?')) return;
    authFetch(API + '/admin/transaction-fees/' + id + '/paid', { method: 'PATCH' })
      .then(function(r) { return r.json(); })
      .then(function(d) {
        if (d && d.success) { showToast && showToast('입금 확인 완료', 'success'); fetchList(); }
        else showToast && showToast((d && d.error) || '처리 실패', 'error');
      });
  }

  function markExempt(id) {
    var reason = window.prompt('면제 사유를 입력하세요 (필수)');
    if (!reason || !reason.trim()) return;
    authFetch(API + '/admin/transaction-fees/' + id + '/exempt', {
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ reason: reason.trim() })
    })
      .then(function(r) { return r.json(); })
      .then(function(d) {
        if (d && d.success) { showToast && showToast('면제 처리 완료', 'success'); fetchList(); }
        else showToast && showToast((d && d.error) || '처리 실패', 'error');
      });
  }

  function statusBadge(s) {
    if (s === 'paid') return badge ? badge('active', '입금완료') : '입금완료';
    if (s === 'exempt') return badge ? badge('none', '면제') : '면제';
    return badge ? badge('trial', '미수') : '미수';
  }

  function fmtKrw(n) {
    var v = parseInt(n, 10) || 0;
    return v.toLocaleString('ko-KR') + '원';
  }

  return (
    <div>
      <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 16 }}>
        <h3 style={{ margin: 0, fontSize: 16, fontWeight: 700, color: '#1B3A5C' }}>💰 거래수수료 (33,000원/건)</h3>
        <select value={status} onChange={function(e) { setStatus(e.target.value); }} style={{ padding: '6px 10px', fontSize: 13, border: '1px solid #d0d5dd', borderRadius: 6 }}>
          <option value="all">전체</option>
          <option value="pending">미수</option>
          <option value="paid">입금완료</option>
          <option value="exempt">면제</option>
        </select>
        <label style={{ fontSize: 13, color: '#64748b', display: 'flex', alignItems: 'center', gap: 4 }}>
          <input type="checkbox" checked={overdue} onChange={function(e) { setOverdue(e.target.checked); }} />
          D+15 초과만
        </label>
        <button onClick={fetchList} style={Object.assign({}, btnStyle, { padding: '6px 14px' })}>새로고침</button>
      </div>

      {loading ? (
        <div style={{ fontSize: 13, color: '#94a3b8' }}>불러오는 중...</div>
      ) : items.length === 0 ? (
        <div style={{ fontSize: 13, color: '#94a3b8', padding: 20, textAlign: 'center', background: '#f8fafc', borderRadius: 8 }}>
          조건에 맞는 수수료 row 가 없습니다
        </div>
      ) : (
        <div style={{ overflowX: 'auto' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead>
              <tr>
                <th style={th}>ID</th>
                <th style={th}>경매</th>
                <th style={th}>출품자</th>
                <th style={th}>낙찰자</th>
                <th style={th}>총액</th>
                <th style={th}>인계일</th>
                <th style={th}>납기일</th>
                <th style={th}>상태</th>
                <th style={th}>작업</th>
              </tr>
            </thead>
            <tbody>
              {items.map(function(r) {
                return (
                  <tr key={r.id}>
                    <td style={td}>{r.id}</td>
                    <td style={td}>#{r.auction_id} {r.auction_title || ''}</td>
                    <td style={td}>{r.seller_company_name || '-'}</td>
                    <td style={td}>{r.buyer_name || '-'}</td>
                    <td style={Object.assign({}, td, { fontWeight: 700 })}>{fmtKrw(r.amount_total)}</td>
                    <td style={td}>{(r.delivered_at || '').slice(0, 10)}</td>
                    <td style={td}>{(r.due_date || '').slice(0, 10)}</td>
                    <td style={td}>{statusBadge(r.status)}</td>
                    <td style={td}>
                      {r.status === 'pending' && (
                        <span>
                          <button onClick={function() { markPaid(r.id); }} style={{ padding: '4px 10px', fontSize: 11, background: '#16a34a', color: '#fff', border: 'none', borderRadius: 4, cursor: 'pointer', marginRight: 6 }}>입금확인</button>
                          <button onClick={function() { markExempt(r.id); }} style={{ padding: '4px 10px', fontSize: 11, background: '#64748b', color: '#fff', border: 'none', borderRadius: 4, cursor: 'pointer' }}>면제</button>
                        </span>
                      )}
                      {r.status === 'paid' && r.paid_at && (
                        <span style={{ fontSize: 11, color: '#64748b' }}>{(r.paid_at || '').slice(0, 10)}</span>
                      )}
                      {r.status === 'exempt' && r.exempt_reason && (
                        <span style={{ fontSize: 11, color: '#64748b' }} title={r.exempt_reason}>{r.exempt_reason.length > 20 ? r.exempt_reason.slice(0, 20) + '...' : r.exempt_reason}</span>
                      )}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}

export default AdminTransactionFees;
